/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { ICommisionJunctionViewProps } from './commision-junction';

class CommisionJunctionViewProps extends React.PureComponent<ICommisionJunctionViewProps> {
    public constructor(props: ICommisionJunctionViewProps) {
        super(props);
    }

    public windowFunction(): void {
        if (this.props.isCJEnabled) {
            this.props.siteTag && this._addSiteTag();
            this.props.conversionTag && this._addConversionTag();
        }
    }

    public componentDidMount(): void {
        this.windowFunction();
    }

    public componentDidUpdate(): void {
        this.windowFunction();
        const script = document.createElement('script');
        script.src = 'https://www.mczbf.com/tags/12703/tag.js';
        script.type = 'text/javascript';
        script.async = true;
        script.id = 'cjapitag';
        document.body.appendChild(script);
    }

    public render(): JSX.Element | null {
        return <></>;
    }

    /**
     * HandlePageLoad.
     */
    private readonly _addSiteTag = () => {
        if (!(window as any).cj) {
            (window as any).cj = {};
        }
        (window as any).cj.sitePage = this.props.siteTag;
    };

    private readonly _addConversionTag = () => {
        if (!(window as any).cj) {
            (window as any).cj = {};
        }
        (window as any).cj.order = this.props.conversionTag;
    };
}
export default CommisionJunctionViewProps;
